import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { MapPin, ArrowRight } from "lucide-react";
import { CITIES } from "@/data/cities";

export default function CitiesGrid({ title, subtitle, excludeSlug }) {
  const list = excludeSlug ? CITIES.filter((c) => c.slug !== excludeSlug) : CITIES;
  return (
    <section data-testid="cities-section" className="bg-[#f8fafc] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mb-14">
          <div className="text-sm uppercase tracking-[0.25em] text-[#066ec4] font-bold mb-4">
            Zones d'intervention
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight text-[#00367e] leading-[1.1]">
            {title || (<>20 villes desservies en <span className="dh-underline">Seine-et-Marne</span></>)}
          </h2>
          {subtitle ? (
            <p className="mt-5 text-lg text-slate-700">{subtitle}</p>
          ) : (
            <p className="mt-5 text-lg text-slate-700">
              Notre équipe technique intervient dans tout Melun et son agglomération, et plus largement dans toute la Seine-et-Marne (77). Cliquez sur votre ville pour découvrir notre service local.
            </p>
          )}
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
          {list.map((c, i) => (
            <motion.div
              key={c.slug}
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.1 }}
              transition={{ duration: 0.35, delay: Math.min(i * 0.02, 0.3) }}
            >
              <Link
                to={`/${c.slug}`}
                data-testid={`city-card-${c.slug}`}
                className="group flex items-center justify-between gap-2 bg-white rounded-2xl p-4 border border-slate-200 hover:border-[#066ec4] hover:bg-[#00367e] hover:text-white transition-all duration-300 h-full shadow-[0_2px_10px_rgba(0,54,126,0.04)]"
              >
                <div className="min-w-0">
                  <div className="flex items-center gap-1.5 text-[11px] uppercase tracking-wider text-[#066ec4] group-hover:text-white/70 font-bold">
                    <MapPin size={12} /> {c.postal}
                  </div>
                  <div className="font-bold text-[#00367e] group-hover:text-white text-[14.5px] truncate">{c.name}</div>
                </div>
                <ArrowRight size={16} className="text-slate-400 group-hover:text-white shrink-0" />
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
